/**
 * Application Routes
 *
 * All analytics routes now use the dynamic /app/analytics/:factId pattern.
 */

export const ROUTES = {
  // Public
  HOME: '/',
  PRICING: '/pricing',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  ACCEPT_INVITE: '/accept-invite',

  // Onboarding
  ONBOARDING: '/onboarding',

  // App - Dashboard
  DASHBOARD: '/app',

  // Dynamic Analytics Route (DataModel-driven)
  // Usage: ROUTES.ANALYTICS('mrr_daily') -> '/app/analytics/mrr_daily'
  ANALYTICS: (factId: string) => `/app/analytics/${factId}`,

  // Dedicated Analytics Pages
  GEOGRAPHY: '/app/geography',
  CUSTOMERS: '/app/customers',
  BRANDS: '/app/brands',
  CATEGORIES: '/app/categories',
  PRODUCTS: '/app/products',
  CHANNELS: '/app/channels',
  RETENTION: '/app/retention',
  INVENTORY: '/app/inventory',
  SUPPLIER_ORDERS: '/app/supplier-orders',
  ORDERS: '/app/orders',
  FULFILLMENT: '/app/fulfillment',
  PNL: '/app/pnl',
  SEASONALITY: '/app/seasonality',
  SMART_REORDER: '/app/smart-reorder',

  // Generic Catalog (paginated browse)
  CATALOG: (type: string) => `/app/catalog/${type}`,

  // Resource Detail (drill-down)
  BRAND_DETAIL: (value: string) => `/app/brands/${encodeURIComponent(value)}`,
  CATEGORY_DETAIL: (value: string) => `/app/categories/${encodeURIComponent(value)}`,
  PRODUCT_DETAIL: (value: string) => `/app/products/${encodeURIComponent(value)}`,
  GEOGRAPHY_DETAIL: (value: string) => `/app/geography/${encodeURIComponent(value)}`,
  SUPPLIER_DETAIL: (value: string) => `/app/suppliers/${encodeURIComponent(value)}`,
  CUSTOMER_DETAIL: (value: string) => `/app/customer/${encodeURIComponent(value)}`,

  // Upload
  UPLOAD: '/app/upload',

  // Settings
  SETTINGS: '/app/settings',
  SETTINGS_GENERAL: '/app/settings/general',
  SETTINGS_PROFILE: '/app/settings/profile',
  SETTINGS_BILLING: '/app/settings/billing',
  SETTINGS_TEAM: '/app/settings/team',
  SETTINGS_CONNECTORS: '/app/settings/connectors',
  SETTINGS_JOBS: '/app/settings/jobs',

  // Admin (super_admin god mode)
  ADMIN: '/admin',
  ADMIN_TENANTS: '/admin/tenants',
} as const

/**
 * Resolve the post-login landing path based on the user's role.
 * super_admin → `/admin/tenants` so they don't see the tenant-scoped
 * dashboard (which would just emit 403s for every analytics call,
 * since super_admin has tenant_id=NULL).
 */
export function landingPathForUser(user: { role?: string | null } | null | undefined): string {
  if (user?.role === 'super_admin') return ROUTES.ADMIN_TENANTS
  return ROUTES.DASHBOARD
}
